import { renderColumnWithEllipsis } from '@common/utils/renderUtils';
import { theme } from '@prophecy/theme';
import { ColumnsType, Stack, Table } from '@prophecy/ui-v3';
import React from 'react';

import { Log, StatusMapKeys, StatusMap } from '../config';
import { InfoTableHeader } from '../ImportedInfo/util';

export const Logs = ({ logs }: { logs: Log[] }) => {
  const columns: ColumnsType<Log> = [
    {
      key: 'logType',
      dataIndex: 'logType',
      title: 'Status',
      width: '120px',
      render: (status) => {
        return (
          <Stack direction='horizontal' alignY='center' gap={theme.spaces.x12}>
            {StatusMap[status as StatusMapKeys]}
            {status}
          </Stack>
        );
      }
    },
    {
      key: 'msg',
      dataIndex: 'msg',
      title: 'Message',
      render: (msg) => renderColumnWithEllipsis(msg, undefined, undefined, true)
    }
  ];
  return (
    <Stack gap={theme.spaces.x12} grow='1' padding={`0 0 ${theme.spaces.x16}`}>
      <InfoTableHeader title='Logs' count={logs.length} />
      <Table
        virtualize={true}
        fixedHeader={true}
        height='100%'
        width='100%'
        columns={columns}
        dataSource={logs}
        data-test-id='transpiler-logs-table'
      />
    </Stack>
  );
};
